export default __webpack_public_path__ + "999443fc79d7f3b49b9aefa6f35fa57c.png";